{
  "title": "LX CONNECT",
  "menu": {
    "applications": "Applicatifs",
    "back": "Retour",
    "campaigns": "Campagnes",
    "dashboard": "Tableau de bord",
    "devices": "Postes locaux S4",
    "dtwins": {
      "label": "Équipements",
      "manage": {
        "fleets": "Flottes",
        "label": "Gérer",
        "devices": "Équipements"
      },
      "overview": {
        "label": "Aperçu",
        "map": "Carte"
      }
    },
    "logout": "Déconnexion",
    "logs": "Logs",
    "overview": "Synthèse",
    "parameters": {
      "label": "Paramètres",
      "platformMgt": "Gestion de la plateforme",
      "features": {
        "applicationManagement": "Applications",
        "firmwareManagement": "Firmwares",
        "deviceConfiguration": "Configuration des équipements",
        "label": "Fonctionnalités",
        "licenseManagement": "Licence",
        "interfaces": "Interfaces"
      },
      "monitoring": {
        "label": "Monitoring",
        "settings": "Reporting"
      }
    },
    "product": "Produit",
    "sector": {
      "label": "Secteur",
      "placeholder": "Sélectionner un secteur"
    },
    "sectors": "Secteurs",
    "settings": "Administration",
    "users": "Utilisateurs"
  },
  "header": {
    "sectors": "Secteurs",
    "userMenu": {
      "title": "Menu du compte",
      "logout": "Déconnexion",
      "userAccount": "Compte utilisateur",
      "about": "À propos",
      "connectMyMobileApp": "Connecter mon application mobile"
    },
    "admin": "Administration",
    "delegation": {
      "select": {
        "label": "Sélectionnez une organisation",
        "title": "Sélectionnez une organisation"
      }
    }
  }
}
